module.exports = __webpack_public_path__ + "static/media/07.fbbf9d32.jpg";